module.exports = __webpack_public_path__ + "static/media/carl.c3d7fc20.jpg";